/**
 * LoadingSpinner - 加载动画组件
 */

import React from 'react';
import styles from './LoadingSpinner.module.css';

function LoadingSpinner({ full = false, size = 'medium', text = '' }) {
  return (
    <div className={`${styles.wrapper} ${full ? styles.full : ''}`}>
      <div className={`${styles.spinner} ${styles[size]}`} />
      {text && <p className={styles.text}>{text}</p>}
    </div>
  );
}

export default LoadingSpinner;
